import { createRef } from 'react';
import Form from 'Component/Form';
import './MyAccountAddressForm.style.plugin'

const renderFormBody = (args, callback, instance) => {
    const fields = instance.fieldMap;
    const firstnameField = fields.find(af => af.attr.name === 'firstname');
    firstnameField.events = {
        onChange: instance.props.onFirstnameChange
    }
    const lastnameField = fields.find(af => af.attr.name === 'lastname');
    lastnameField.events = {
        onChange: instance.props.onLastnameChange
    }
    const streetGroupFields = fields.find(af => af.name === 'streetGroup').fields;
    streetGroupFields[0].events = {
        onChange: instance.props.onStreet0Change
    }

    return (
        <div block="FieldForm" elem="Body">
            <div block="FieldForm" elem="Fields">
                { fields.map(instance.renderSection.bind(instance)) }
            </div>
            <div block="FieldForm" elem="Validation">
                { instance.renderValidationMessage() }
            </div>
            { instance.renderActions() }
        </div>
    );
}

// const __construct = (args, callback, instance) => {
//     const [props] = args;
//     callback(...args);
//     instance.formRef = createRef();
// }

const getFormProps = (args, callback, instance) => {
    return {
        ...callback(...args),
        elemRef: instance.props.formRef
    }
}

const render = (args, callback, instance) => {
    return (
        <Form { ...instance.getFormProps() } block="FieldForm">
            { instance.renderFormBody() }
        </Form>
    );
}

const renderValidationMessage = (args, callback, instance) => {
    if (instance.props.countryId !== 'CH') {
        return null;
    }

    switch(instance.props.validationState) {
        case 'CERTIFIED':
            return (
                <div block="Notification" mods={ { type: 'success', isValidation: true } }>
                    <p block="Notification" elem="Text">
                        { __('The delivery address was successfully validated.') }
                    </p>
                </div>
            );
        case 'VALID':
            return (
                <div block="Notification" mods={ { type: 'info', isValidation: true } }>
                    <p block="Notification" elem="Text">
                        { __('The delivery address is valid but could not be verified. Please check that the delivery address is correct and then continue.') }
                    </p>
                </div>
            );
        case 'NOT VALID':
            return (
                <div block="Notification" mods={ { type: 'error', isValidation: true } }>
                    <p block="Notification" elem="Text">
                        { __('The validation of the delivery address has shown that it is invalid. Please check the correctness of the delivery address before you continue.') }
                    </p>
                </div>
            );
        case 'ERROR':
            return (
                <div block="Notification" mods={ { type: 'error', isValidation: true } }>
                    <p block="Notification" elem="Text">
                        { __('An error occurred during the validation of the delivery address.') }
                    </p>
                </div>
            );
    }
    return null;
}

export default {
    'Component/MyAccountAddressForm/Component': {
        'member-function': {
            renderFormBody,
            getFormProps,
            renderValidationMessage,
            render
        }
    }
}
